"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = [
    'black',
    'red',
    'orange',
    'yellow',
    'olive',
    'green',
    'teal',
    'blue',
    'purple',
    'violet',
    'pink',
    'brown',
    'grey',
];
